import React from "react";

function SupportDownloads() {
  return (
    <div className="support-downloads-container" style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <h1>Support & Downloads</h1>

    </div>
  );
}

export default SupportDownloads;
